export default __webpack_public_path__ + "static/media/TheGeorge.4be739c9.jpg";